import React from 'react';
import PropTypes from 'prop-types';
import { useAtomValue } from 'jotai';
import { useIntl } from 'react-intl';
import { Fade } from '@mui/material';
import {
  outcomesAtom,
  selectedCustomerIdAtom,
  selectedLeadIdAtom,
} from '../../Atoms';
import ActivityHistoryList from '../Activities/ActivityHistoryList';
import WidgetBox from './WidgetBox';
import StatsBox from './StatsBox';
import EntriesWrapper from '../ContactListWrapper/EntriesWrapper';

const useStyles = () => ({
  defaultLayoutStyle: {
    gap: '16px',
    height: '100%',
  },
  historyStyle: {
    display: 'flex',
    flexDirection: 'column',
    width: '30%',
    gap: '16px',
  },
});

const SectionPage = function SectionPage({
  disableClickRow = false,
  customStatusChipCallback = null,
  rowSxCallback = null,
  stats = null,
  sectionSubName = null,
  ListObserverWrapper,
  ExportToExcel = () => {},
  StatsObserverWrapper = () => {},
  activitiesCount = 0,
  mainBoxWidth = '100%',
  tablet = false,
  heightQuery = false,
  hideExportExcel = false,
  hideFilters = false,
  hideSearchBar = false,
  hideSorting = false,
  fab = null,
  onClickFab = () => {},
  customFab = null,
  customEntryFunction = undefined,
  fabVariant = null,
  customFilters = null,
  singlePageList = null,
  removeFromList = () => {},
  updateItem = () => {},
  sortingOptions = [],
  wavePeriod = '',
  filters = [],
  sectionName,
  tabs = [],
  tabValue = 0,
  onChangeTabValue = () => {},
  columns = [],
  hideStats = false,
  customClick = undefined,
  sideWidget = null, //replaces the today calls box
}) {
  const intl = useIntl();
  const classes = useStyles();

  const selectedLeadId = useAtomValue(selectedLeadIdAtom);
  const outcomes = useAtomValue(outcomesAtom);
  const selectedCustomerId = useAtomValue(selectedCustomerIdAtom);

  return (
    <Fade in={!selectedCustomerId || !selectedLeadId}>
      <div
        style={{
          ...classes.defaultLayoutStyle,
          display: selectedCustomerId || selectedLeadId ? 'none' : 'flex',
        }}
      >
        <EntriesWrapper
          disableClickRow={disableClickRow}
          customStatusChipCallback={customStatusChipCallback}
          rowSxCallback={rowSxCallback}
          filters={filters}
          wavePeriod={wavePeriod}
          singlePageList={singlePageList}
          customFilters={customFilters}
          hideFilters={hideFilters}
          hideExportExcel={hideExportExcel}
          hideSearchBar={hideSearchBar}
          hideSorting={hideSorting}
          sortingOptions={sortingOptions}
          providedWidth={mainBoxWidth}
          providedHeight="100%"
          title={sectionName}
          caption={sectionSubName}
          ObserverWrapper={ListObserverWrapper}
          ExportToExcel={ExportToExcel}
          customEntryFunction={customEntryFunction}
          customClick={customClick}
          fab={fab}
          fabVariant={fabVariant}
          onClickFab={onClickFab}
          customFab={customFab}
          removeFromList={removeFromList}
          updateItem={updateItem}
          columns={columns}
        />
        {tablet && (
          <div style={classes.historyStyle}>
            {sideWidget ?? (
              <WidgetBox
                flex="1 1 auto"
                height="50%"
                title={intl.messages.TODAY_CALLS}
                widget={
                  <ActivityHistoryList
                    outcomes={outcomes}
                    ObserverWrapper={StatsObserverWrapper}
                    callsCount={activitiesCount}
                  />
                }
              />
            )}
            {!hideStats && (
              <StatsBox
                tabs={tabs}
                tabValue={tabValue}
                onChangeTabValue={onChangeTabValue}
                outcomes={outcomes}
                wavePeriod={wavePeriod}
                heightQuery={heightQuery}
                stats={stats}
              />
            )}
          </div>
        )}
      </div>
    </Fade>
  );
};

SectionPage.propTypes = {
  sectionName: PropTypes.string.isRequired,
  stats: PropTypes.object,
  ListObserverWrapper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ExportToExcel: PropTypes.func,
  StatsObserverWrapper: PropTypes.func,
  activitiesCount: PropTypes.number,
  mainBoxWidth: PropTypes.string,
  sectionSubName: PropTypes.string,
  tablet: PropTypes.bool,
  heightQuery: PropTypes.bool,
  // defaultRating: PropTypes.array,
  hideExportExcel: PropTypes.bool,
  hideFilters: PropTypes.bool,
  hideSearchBar: PropTypes.bool,
  hideSorting: PropTypes.bool,
  fab: PropTypes.string,
  onClickFab: PropTypes.func,
  customFab: PropTypes.node,
  CustomEmptyList: PropTypes.node,
  customEntryFunction: PropTypes.func,
  fabVariant: PropTypes.string,
  customFilters: PropTypes.node,
  singlePageList: PropTypes.array,
  removeFromList: PropTypes.func,
  updateItem: PropTypes.func,
  sortingOptions: PropTypes.array,
  wavePeriod: PropTypes.string,
  filters: PropTypes.array,
  tabs: PropTypes.array,
  tabValue: PropTypes.number,
  onChangeTabValue: PropTypes.func,
  rowSxCallback: PropTypes.func,
};

export default SectionPage;
